import { createAction } from 'typesafe-actions';
import type { CovieState } from '../reducer/v2/verifyPolicy';

export const updateCovieAction = createAction('covie/update')<CovieState>();
